import { render, staticRenderFns } from "./ArticleCommitteePage.vue?vue&type=template&id=73b0cc6e&scoped=true"
import script from "./ArticleCommitteePage.vue?vue&type=script&lang=js"
export * from "./ArticleCommitteePage.vue?vue&type=script&lang=js"
import style0 from "./ArticleCommitteePage.vue?vue&type=style&index=0&id=73b0cc6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b0cc6e",
  null
  
)

export default component.exports